<template>
  <div :data-test="`${$route.name}Page`" class="c-errorPage">
    <div class="l-container">
      <div class="l-container--inner c-errorPage--content">
        <h1>{{ content.error_page_not_found_title }}</h1>
        <p>{{ content.error_page_not_found_description }}</p>
        <p>
          <f-button button-type="primary" href="/">
            {{ content.error_page_not_found_button }}
          </f-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FButton from '@justeat/f-button'

export default {
  name: 'PageNotFound',
  components: { FButton },
  computed: {
    ...mapGetters(['content'])
  }
}
</script>
